// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1wQe9","label":"Completed_label__1rFV-"};